import React from "react";
import Card from "canvas-core-react/lib/Card";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import { ButtonOk } from "../buttonOk";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import "./style.scss";

export interface EndCoachProps {
  id?: string;
  text?: string;
}
export const EndCoach = ({
  id, text
}: EndCoachProps) => {

  const refresh = () => {
    window.location.reload();
  }
  const back = () => {
    window.location.replace("https://www.scotiabank.cl");
  }
  return (
    <Card data-testid="EndCoach">
      <div id={id}
      >{text}</div>
      <Row>
        <Margin xs={6} sm={6} md={6} lg={6}>
          <Column xs={4} sm={8} md={12} lg={12}>
            <PrimaryButton onClick={refresh} className={`endCoach endCoach__button-refresh`}>Repetir entrenamiento</PrimaryButton>
          </Column>
        </Margin>
      </Row>
      <Row>
        <Margin xs={6} sm={6} md={6} lg={6}>
          <Column xs={4} sm={8} md={12} lg={12}>
            <ButtonOk title="Volver al home" onClick={back} isLarge={true}></ButtonOk>
          </Column>
        </Margin>
      </Row>

    </Card>
  );
};
